import { HeaderService } from '@my-backoffice/app/pages/main/shared/components/header/shared/service/header.service';
import { ILanguage, LANGUAGES } from '@my-backoffice/app/shared/constants/languages.constants';
import { ELocalForageKeys } from '@my-backoffice/app/shared/models/enums/localforage-keys.enum';
import { QimaColorService } from '@my-backoffice/app/shared/services/exported-services/qima-color/qima-color.service';
import { QimaDotService } from '@my-backoffice/app/shared/services/exported-services/qima-dot/qima-dot.service';
import { QimaShadowService } from '@my-backoffice/app/shared/services/exported-services/qima-shadow/qima-shadow.service';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { QimaShadowDirectiveModule, QimaDotModule } from '@qima/ngx-qima';
import localforage from 'localforage';

@UntilDestroy()
@Component({
  selector: 'app-translate-menu',
  standalone: true,
  templateUrl: './translate-menu.component.html',
  styleUrls: ['./translate-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [QimaShadowDirectiveModule, QimaDotModule, TranslateModule],
})
export class TranslateMenuComponent implements OnInit {
  public translateMenuItems: ILanguage[] = LANGUAGES;
  public activeIndex: number = this.translateMenuItems.findIndex((item): boolean => item.value === this._translateService.currentLang);

  public constructor(
    private readonly _translateService: TranslateService,
    private readonly _headerService: HeaderService,
    public readonly shadowService: QimaShadowService,
    public readonly qimaDot: QimaDotService,
    public readonly qimaColor: QimaColorService
  ) {}

  public ngOnInit(): void {
    this._watch();
  }

  public onTranslateMenuItemClick(index: number): void {
    this._onItemClick(index);
  }

  public onTranslateMenuItemEnter(index: number): void {
    this._onItemClick(index);
  }

  private _watch(): void {
    this._headerService.activeLanguageIndex$.pipe(untilDestroyed(this)).subscribe((index: number): void => {
      this.activeIndex = index;
    });
  }

  private _onItemClick(index: number): void {
    const language = this.translateMenuItems[index].value;

    void localforage.setItem(ELocalForageKeys.LOCALE_LANGUAGE, language);

    this._updateActiveLanguageIndex(index);
    this._closeMenu();
    this._translateService.use(language).pipe(untilDestroyed(this)).subscribe();
  }

  private _updateActiveLanguageIndex(index: number): void {
    this._headerService.updateActiveLanguageIndex(index);
  }

  private _closeMenu(): void {
    this._headerService.updateIsTranslateMenuVisible(false);
  }
}
